import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CookieConsent } from "@/components/CookieConsent";
import Index from "./pages/Index";
import DepannageUrgence from "./pages/DepannageUrgence";
import OuverturePorte from "./pages/OuverturePorte";
import ChangementSerrure from "./pages/ChangementSerrure";
import ReparationSerrure from "./pages/ReparationSerrure";
import VoletRoulant from "./pages/VoletRoulant";
import PorteBlindeeGarage from "./pages/PorteBlindeeGarage";
import ZonesIntervention from "./pages/ZonesIntervention";
import Charpennes from "./pages/Charpennes";
import Republique from "./pages/Republique";
import GratteCiel from "./pages/GratteCiel";
import Cusset from "./pages/Cusset";
import Flachet from "./pages/Flachet";
import LaurentBonnevay from "./pages/LaurentBonnevay";
import CroixLuizet from "./pages/CroixLuizet";
import Ferrandiere from "./pages/Ferrandiere";
import MaisonsNeuves from "./pages/MaisonsNeuves";
import Perraliere from "./pages/Perraliere";
import Salengro from "./pages/Salengro";
import SaintJean from "./pages/SaintJean";
import Buers from "./pages/Buers";
import Tonkin from "./pages/Tonkin";
import Zola from "./pages/Zola";
import Tolstoi from "./pages/Tolstoi";
import GrandClement from "./pages/GrandClement";
import ChateauGaillard from "./pages/ChateauGaillard";
import Lyon1 from "./pages/Lyon1";
import Lyon2 from "./pages/Lyon2";
import Lyon3 from "./pages/Lyon3";
import Lyon4 from "./pages/Lyon4";
import Lyon5 from "./pages/Lyon5";
import Lyon6 from "./pages/Lyon6";
import Lyon7 from "./pages/Lyon7";
import Lyon8 from "./pages/Lyon8";
import Lyon9 from "./pages/Lyon9";
import Bron from "./pages/Bron";
import VaulxEnVelin from "./pages/VaulxEnVelin";
import Caluire from "./pages/Caluire";
import Meyzieu from "./pages/Meyzieu";
import Decines from "./pages/Decines";
import Rillieux from "./pages/Rillieux";
import Venissieux from "./pages/Venissieux";
import SaintPriest from "./pages/SaintPriest";
import Tassin from "./pages/Tassin";
import Oullins from "./pages/Oullins";
import PierreBenite from "./pages/PierreBenite";
import Dardilly from "./pages/Dardilly";
import Ecully from "./pages/Ecully";
import SaintGenisLaval from "./pages/SaintGenisLaval";
import Francheville from "./pages/Francheville";
import SainteFoy from "./pages/SainteFoy";
import Neuville from "./pages/Neuville";
import Fontaines from "./pages/Fontaines";
import Sathonay from "./pages/Sathonay";
import Contact from "./pages/Contact";
import MentionsLegales from "./pages/MentionsLegales";
import LandingAds from "./pages/LandingAds";
import NotFound from "./pages/NotFound";
import StructuredData from "./components/StructuredData";
import { ScrollToTop } from "./components/ScrollToTop";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <StructuredData />
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <CookieConsent />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/depannage-urgence" element={<DepannageUrgence />} />
          <Route path="/ouverture-porte" element={<OuverturePorte />} />
          <Route path="/changement-serrure" element={<ChangementSerrure />} />
          <Route path="/reparation-serrure" element={<ReparationSerrure />} />
          <Route path="/volet-roulant" element={<VoletRoulant />} />
          <Route path="/porte-blindee-garage" element={<PorteBlindeeGarage />} />
          <Route path="/zones-intervention" element={<ZonesIntervention />} />
          <Route path="/charpennes" element={<Charpennes />} />
          <Route path="/republique" element={<Republique />} />
          <Route path="/gratte-ciel" element={<GratteCiel />} />
          <Route path="/cusset" element={<Cusset />} />
          <Route path="/flachet" element={<Flachet />} />
          <Route path="/laurent-bonnevay" element={<LaurentBonnevay />} />
          <Route path="/croix-luizet" element={<CroixLuizet />} />
          <Route path="/ferrandiere" element={<Ferrandiere />} />
          <Route path="/maisons-neuves" element={<MaisonsNeuves />} />
          <Route path="/perraliere" element={<Perraliere />} />
          <Route path="/salengro" element={<Salengro />} />
          <Route path="/saint-jean" element={<SaintJean />} />
          <Route path="/buers" element={<Buers />} />
          <Route path="/tonkin" element={<Tonkin />} />
          <Route path="/zola" element={<Zola />} />
          <Route path="/tolstoi" element={<Tolstoi />} />
          <Route path="/grand-clement" element={<GrandClement />} />
          <Route path="/chateau-gaillard" element={<ChateauGaillard />} />
          <Route path="/lyon-1" element={<Lyon1 />} />
          <Route path="/lyon-2" element={<Lyon2 />} />
          <Route path="/lyon-3" element={<Lyon3 />} />
          <Route path="/lyon-4" element={<Lyon4 />} />
          <Route path="/lyon-5" element={<Lyon5 />} />
          <Route path="/lyon-6" element={<Lyon6 />} />
          <Route path="/lyon-7" element={<Lyon7 />} />
          <Route path="/lyon-8" element={<Lyon8 />} />
          <Route path="/lyon-9" element={<Lyon9 />} />
          <Route path="/bron" element={<Bron />} />
          <Route path="/vaulx-en-velin" element={<VaulxEnVelin />} />
          <Route path="/caluire-et-cuire" element={<Caluire />} />
          <Route path="/meyzieu" element={<Meyzieu />} />
          <Route path="/decines-charpieu" element={<Decines />} />
          <Route path="/rillieux-la-pape" element={<Rillieux />} />
          <Route path="/venissieux" element={<Venissieux />} />
          <Route path="/saint-priest" element={<SaintPriest />} />
          <Route path="/tassin-la-demi-lune" element={<Tassin />} />
          <Route path="/oullins" element={<Oullins />} />
          <Route path="/pierre-benite" element={<PierreBenite />} />
          <Route path="/dardilly" element={<Dardilly />} />
          <Route path="/ecully" element={<Ecully />} />
          <Route path="/saint-genis-laval" element={<SaintGenisLaval />} />
          <Route path="/francheville" element={<Francheville />} />
          <Route path="/sainte-foy-les-lyon" element={<SainteFoy />} />
          <Route path="/neuville-sur-saone" element={<Neuville />} />
          <Route path="/fontaines-sur-saone" element={<Fontaines />} />
          <Route path="/sathonay-camp" element={<Sathonay />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/urgence" element={<LandingAds />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
